import 'construct-style-sheets-polyfill'; // THIS HAS TO BE THE FIRST IMPORT FOR FIREFOX TO WORK CORRECTLY

import { BaseQLClient } from '@adornis/baseql/client/baseqlClient.js';
import { updateDynamicMetadata } from '@adornis/baseql/client/introspection.js';
import { QueryCache } from '@adornis/baseql/client/requestHandlers/queryCache.js';
import { updateDynamicValidators } from '@adornis/cms/db/dynamic-validators.js';
import { subscribeCurrentUser } from '@adornis/users/client/currentUser.js';
import { AdornisUser } from '@adornis/users/db/a-user.js';
import { ChancenDynamicClassFormOfFinanzing } from '@chancenwerk/_cms/financing/entities/ChancenDynamicClassFormOfFinanzing.js';
import { ChancenDynamicClassProduct } from '@chancenwerk/_cms/products/entities/ChancenDynamicClassProduct.js';
import '@chancenwerk/client/translation-data.js';
import '@chancenwerk/design/index.js';

// ====================== Import DB to fill metadata-tree
import '@chancenwerk/db/index.js';
// ====================== Import main-element.ts as 'frontend-entry'
import './main-element.js';
// ====================== Styling

const transportHandler = BaseQLClient.createTransportHandler();
const queryCache = new QueryCache(transportHandler);
BaseQLClient.initHandler(queryCache);
subscribeCurrentUser(() => ({
  ...AdornisUser.allFields,
  vorname: 1,
  nachname: 1,
  lastCampusLogin: 1,
}));

// Update the dynmic schema for cms
void updateDynamicMetadata().then(() => {
  void updateDynamicValidators([ChancenDynamicClassProduct._class, ChancenDynamicClassFormOfFinanzing._class]);
});

//
// Init App
//

import { html } from 'lit';
import { webcomponent } from '@adornis/functional-lit/webcomponent.js';
import { initApp } from '@adornis/functional-lit/init-app.js';

const root = document.getElementById('root');
if (root) {
  root.style.backgroundColor = 'rgb(242, 242, 242)';
}

initApp(
  webcomponent('root-element', () => html`<main-element></main-element>`, {
    shadowRoot: true,
    styles: {
      ':host': {
        overflow: 'auto',
      },
    },
  }),
);
